import { errorValidation } from './utils';

/**
 * Validate forms
 */
(() => {
	// Filters
	$("form[name='filters']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'filters[pickup_loc]': {
				required: true,
			},
			'filters[delivery_loc]': {
				required: true,
			},
		},
		messages: {
			'filters[pickup_loc]': {
				required: window.translations.required,
			},
			'filters[delivery_loc]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
	// Mobile filters
	$("form[name='mob_filters']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'filters[pickup_loc]': {
				required: true,
			},
			'filters[delivery_loc]': {
				required: true,
			},
		},
		messages: {
			'filters[pickup_loc]': {
				required: window.translations.required,
			},
			'filters[delivery_loc]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();

$("form[name='filters'] input[name='filters[pickup_dh]']").on(
	'input',
	function () {
		let value = $(this).val();
		if (value > 500) {
			$(this).val(500);
		}
	}
);

$("form[name='filters'] input[name='filters[delivery_dh]']").on(
	'input',
	function () {
		let value = $(this).val();
		if (value > 500) {
			$(this).val(500);
		}
	}
);

$(document).on('click', '.set_filters_search', function (event) {
	event.preventDefault();
	let type = $(this).data('type');

	let filters_form;
	if (type == 'mobile') {
		filters_form = $("form[name='mob_filters']");
	} else {
		filters_form = $("form[name='filters']");
	}

	let ajax__list = $('.dashboard__list .dashboard__body');
	let ajax__filters = $('.dashboard__filters');
	let ajax__filters_mob = $('.dashboard__filters_mob');
	let ajax__filters_search = $('.dashboard__filters_search');
	let ajax__filters_count = $('.dashboard__filters_count');

	if (filters_form.valid()) {
		let filters = filters_form.serializeArray();

		let allData = {};
		$.each(filters, function (index, field) {
			if (field.name.startsWith('filters[trailer_types]')) {
				let match = field.name.match(/filters\[trailer_types\]\[([^\]]+)\]/);
				if (match) {
					allData['filters[trailer_types]'] =
						allData['filters[trailer_types]'] || [];
					allData['filters[trailer_types]'].push(match[1]);
				}
			} else {
				allData[field.name] = field.value;
			}
		});

		ajax__list.css({
			opacity: 0.6,
		});

		if (type == 'mobile') {
			$('.dashboard__filters_mob').removeClass('_active');
			$('body').removeClass('_lock');
		}

		$.ajax({
			url: '/' + lang + '/dashboard/filters_search?type=filters&action=set', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: allData,
			success: function (data) {
				if (data.status == 'ok') {
					// window.location.reload();
					ajax__list.html(data.view);
					ajax__filters.replaceWith(data.filters);
					ajax__filters_mob.replaceWith(data.filters_mob);
					ajax__filters_search.replaceWith(data.filters_search);
					ajax__filters_count.replaceWith(data.filters_count);
					ajax__list.css({
						opacity: 1,
					});

					AttachSelector();
					AttachSpoller();
					AttachPlaceholder(data.pickup_date);
					AttachPopup();
				}
			},
			// error: function (data) {
			// 	console.log(data); // выводим ошибку в консоль
			// },
			error: function (jqXHR, textStatus, errorThrown) {
				console.log('Status:', jqXHR.status); // Should be 200
				console.log('Response Text:', jqXHR.responseText); // Log the raw response
				console.log('Text Status:', textStatus); // Should be "parsererror" if JSON parsing failed
				console.log('Error Thrown:', errorThrown); // Additional error info
			},
		});
	}
});
